export default "__VITE_ASSET__BShwHuGw__"